// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getOnlineCourseFeedback } from '../../apis/course';
import { LoadingType } from '../../types/Common';
import { OnlineCourseFeedbackResponse } from '../../types/OnlineCourseFeedback';
import { getOnlineCourseFeedbackActions } from '../actionCreators/getOnlineCourseFeedbackActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: getOnlineCourseFeedbackActions.success,
  failure: getOnlineCourseFeedbackActions.failure
};

type RequestActionTypes = ActionType<
  typeof getOnlineCourseFeedbackActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const getOnlineCourseFeedbackEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getOnlineCourseFeedbackActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, loadingType = LoadingType.NEW } = action.payload;
      // send api promise
      return getOnlineCourseFeedback(id)
        .then((response: OnlineCourseFeedbackResponse) => {
          // handle success case here
          return getOnlineCourseFeedbackActions.success({
            onlineCourseFeedbackData: response.data.list,
            canReview: response.data.canReview,
            id,
            loadingType
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return getOnlineCourseFeedbackActions.failure({ error });
        });
    })
  );
};
